import { render } from "./AwaitingEstimatesIcon.vue?vue&type=template&id=2fca12e8"
import script from "./AwaitingEstimatesIcon.vue?vue&type=script&lang=js"
export * from "./AwaitingEstimatesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__